import React, {useEffect, useState} from "react";
import {AutoComplete, Button, Col, Form, Input, message, Modal, Row, Space, Switch} from "antd";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditFilled,
  MinusCircleFilled,
  PlusCircleFilled
} from "@ant-design/icons";
import {apiClient} from "../../../../services/ApiClient";
const { confirm } = Modal;

export default function CarSection({onSelect}) {
  let [record, setRecord] = useState(null);
  let [options, setOptions] = useState([]);
  let [formVisible, setFormVisible] = useState(false);
  let [loading, setLoading] = useState(false);
  let [enableSave, setEnableSave] = useState(false);
  let [form] = Form.useForm();

  const mapRecord = (record) => {
    record.displayName = `${record.model} (${record.number}`;
    if(record.model_type) {
      record.displayName += `, ${record.model_type}`
    }
    record.displayName += ")";
    return {
      key: record.id,
      value: record.displayName,
      record: record
    };
  };

  const search = (val) => {
    apiClient.searchDirectoryRecord('car', val)
      .then(res => {
        if(res.success) {
          setOptions(res.records.map(e => { return mapRecord(e) }));
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error("Не удалось выполнить поиск")
      });
  };

  const create = (args) => {
    setLoading(true);
    apiClient.createDirectoryRecord('car', args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const update = (args) => {
    setLoading(true);
    apiClient.updateDirectoryRecord('car', record.id, args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const remove = () => {
    if(!record) {
      return;
    }
    apiClient.removeDirectoryRecord('car', record.id)
      .then(res => {
        if(res.success) {
          setRecord(null);
          setOptions([]);
          onSelect(null);
          if(formVisible) {
            form.resetFields();
          }
        } else {
          message.error("Ошибка");
        }
      })
      .catch(err => {
        message.error(err);
      });
  };

  const renderForm = () => {
    if(!formVisible) {
      return null;
    }
    if(record) {
      form.setFieldsValue({
        "model": record.model,
        "number": record.number,
        "transport_license": record.transport_license,
      });
    }
    return (
      <Form form={form} layout="horizontal" style={{margin: '10px 0'}}
            labelCol={{span: 3}}
            wrapperCol={{span: 10}}
            onFinish={(args) => { record !== null && record.id > 0 ? update(args) : create(args) }}
      >
        <Form.Item
          label="Марка и модель ТС"
          name="model"
          rules={[
            {
              required: true,
              message: 'Укажите Марку и модель ТС',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Гос.рег. знак"
          name="number"
          rules={[
          {
            required: true,
            message: 'Укажите Гос.рег. знак',
          },
        ]}>
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Лицензия (№ и дата)"
          name="transport_license"
          rules={[
            {
              required: true,
              message: 'Укажите сведения о лицензии',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item wrapperCol={{span: 10, offset: 3}} style={{textAlign: "right"}}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    );
  };

  const renderSelectedActions = () => {
    return (
      <>
        {formVisible
          ? <Button type="link" icon={<CloseCircleOutlined/>} onClick={() => setFormVisible(false)}/>
          : <Button type="link" icon={<EditFilled/>} onClick={() => setFormVisible(true)}/>}
        <Button type="link"
                style={{color: 'darkred'}}
                icon={<DeleteOutlined/>}
                onClick={() => {
                  confirm({
                    title:  "Удаление",
                    content: "Вы уверены, что хотите удалить запись?",
                    icon: <DeleteOutlined/>,
                    visible: true,
                    onOk() {
                      remove();
                    },
                  })
                }}/>
      </>
    );
  };

  const renderNotSelectedActions = () => (
    formVisible
      ? <Button type="link" icon={<MinusCircleFilled/>} onClick={() => setFormVisible(false)}/>
      : <Button type="link" icon={<PlusCircleFilled/>} onClick={() => setFormVisible(true)}/>
  );

  const updateEnableSave = (checked) => {
    localStorage.setItem('CarSection.enableSave', String(checked));
    if(!checked) {
      localStorage.removeItem('CarSection.record');
    } else if(record) {
      localStorage.setItem('CarSection.record', JSON.stringify(record));
    }
    setEnableSave(checked);
  };

  useEffect(() => {
    if(localStorage.getItem(`CarSection.enableSave`) === null) {
      setEnableSave(false);
    } else {
      setEnableSave(localStorage.getItem('CarSection.enableSave') === "true");
      const rec = localStorage.getItem('CarSection.record');
      if(rec) {
        updateRecord(JSON.parse(rec));
      }
    }
  }, []);

  const updateRecord = rec => {
    if(rec) {
      localStorage.setItem('CarSection.record', JSON.stringify(rec));
    } else {
      localStorage.removeItem('CarSection.record');
    }
    setRecord(rec);
    onSelect(rec);
  };

  return (
    <>
      <Row align="middle" justify="start">
        <Col span={3}>
          <h3>Автомобиль</h3>
        </Col>
        <Col span={10}>
          <AutoComplete
            style={{width: '100%'}}
            options={options}
            onSelect={(val, opt) => { updateRecord(opt.record); }}
            onSearch={search}
            onChange={(val) => {
              if(val === undefined) {
                setOptions([]);
                updateRecord(null);
                if(formVisible) {
                  form.resetFields();
                }
              } else {
                setRecord({displayName: val});
              }
            }}
            value={record ? record.displayName : ""}
            allowClear={true}
            placeholder="Искать автомобиль..."
          />
        </Col>
        <Col span={1}>
          <Space direction="horizontal">
            {
              record != null && record.id > 0
                ? renderSelectedActions()
                : renderNotSelectedActions()
            }
          </Space>
        </Col>
        <Col span={10} style={{textAlign: 'right'}}>
          <Switch checked={enableSave}
                  checkedChildren="Сохранять"
                  unCheckedChildren="Не сохранять"
                  style={{width: 120}}
                  onChange={(checked, event) => { updateEnableSave(checked) }}/>
        </Col>
      </Row>
      {renderForm()}
    </>
  );
}